import { gql } from '@apollo/client';

export const GET_SEASON_COMPETITIONS = gql`
  query GetSeasonCompetitions($seasonId: ID) {
    getSeasonCompetitions(seasonId: $seasonId) {
      id
      active
      season {
        id
        code
        displayName
        active
      }
      competition {
        id
        code
        displayName
        rank
        autonomousCommunity {
          id
          name
          flagUrl
        }
      }
    }
  }
`;
